import { render, staticRenderFns } from "./CustomerMaterialsQuoteList.vue?vue&type=template&id=ab66fa20&scoped=true&"
import script from "./CustomerMaterialsQuoteList.vue?vue&type=script&lang=js&"
export * from "./CustomerMaterialsQuoteList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerMaterialsQuoteList.vue?vue&type=style&index=0&id=ab66fa20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab66fa20",
  null
  
)

export default component.exports